import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'

const CreateDatabaseInTestModal = ({
    showCreateDatabaseInTestModal,
    setShowCreateDatabaseInTestModal,
    createDatabaseInTest,
}) => {
    const [errorMessage, setErrorMessage] = useState('')

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return createDatabaseInTest(token, fields, setErrorMessage)
    }

    return (
        <TestModal
            showModal={showCreateDatabaseInTestModal}
            setShowModal={setShowCreateDatabaseInTestModal}
            submitTest={handleSubmitTest}
            modalTitle='Create database in test'
            submitButtonText='Create'
            fields={{
                name: true,
                input: true,
                cpuTimeLimit: true,
                memoryLimit: true,
                exactMatch: true,
                ignoreCase: true,
                fixtureFiles: true,
            }}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showCreateDatabaseInTestModal: unitTests.showCreateDatabaseInTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowCreateDatabaseInTestModal: value => {
            dispatch(unitTestsActions.setShowCreateDatabaseInTestModal(value))
        },
        createDatabaseInTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.createDatabaseInTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(CreateDatabaseInTestModal)
